import { Button, Form, Select, Typography } from 'antd';
import React from 'react';
import { errorWithUserMessage } from '../../helpers/NotificationHelper';
import { filterOptionForSearch } from '../../helpers/normalizeForSearch';
import { getCurrentSeasonLabel, getSeasonSelectOptions } from '../../helpers/SeasonHelper';

const { Text } = Typography;

interface Props {
    visible: boolean;
    onClose: () => void;
    selectedCompetitionCount: number;
    onApply: (season: string) => Promise<void>;
}

interface State {
    applying: boolean;
}

class BatchCompetitionSeasonDrawer extends React.PureComponent<Props, State> {
    private formRef = React.createRef<any>();

    public constructor(props: Props) {
        super(props);

        this.state = {
            applying: false,
        };
    }

    public componentDidUpdate = (prevProps: Props): void => {
        if (this.props.visible && !prevProps.visible) {
            this.setState({ applying: false });
            this.formRef.current?.setFieldsValue({
                season: getCurrentSeasonLabel(),
            });
        }
    };

    private handleApply = async (): Promise<void> => {
        const { onApply, onClose } = this.props;

        let values: { season?: string };
        try {
            values = await this.formRef.current.validateFields();
        } catch {
            return;
        }

        const season = (values.season || '').trim();
        if (!season) {
            errorWithUserMessage('Season is required.');
            return;
        }

        this.setState({ applying: true });
        try {
            await onApply(season);
            onClose();
        } finally {
            this.setState({ applying: false });
        }
    };

    public render(): React.ReactElement {
        const { onClose, selectedCompetitionCount } = this.props;
        const { applying } = this.state;

        return (
            <div style={{ padding: '0 4px' }}>
                <Text type="secondary">
                    Choose the season to apply to {selectedCompetitionCount} selected competition
                    {selectedCompetitionCount === 1 ? '' : 's'}. Existing competition data is kept;
                    only the season field changes.
                </Text>
                <Form
                    ref={this.formRef}
                    layout="vertical"
                    style={{ marginTop: 16 }}
                    initialValues={{ season: getCurrentSeasonLabel() }}
                >
                    <Form.Item
                        name="season"
                        label="Season"
                        rules={[
                            {
                                required: true,
                                message: 'Season field is required!',
                            },
                        ]}
                    >
                        <Select
                            showSearch
                            filterOption={filterOptionForSearch}
                            optionFilterProp="label"
                            options={getSeasonSelectOptions()}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Form>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="primary" loading={applying} onClick={this.handleApply}>
                        Apply to selected competitions
                    </Button>
                </div>
            </div>
        );
    }
}

export default BatchCompetitionSeasonDrawer;
